module.exports = __webpack_public_path__ + "img/vertical_3_4_5010.f11eb377.png";